import { MessageFilterTypes } from 'components/SMS/TwoWay/Model';
import {
    Message,
    Meta,
    ProspectConversation,
    ProspectConversationDetail,
    ProspectMessage
} from 'model/ProspectMessage';
import { Action } from 'redux';

export const PROSPECTMESSAGES_RESET_ACTION_TYPE = 'PROSPECTMESSAGES_RESET';
export const PROSPECTMESSAGES_CLEAR_ACTION_TYPE = 'PROSPECTMESSAGES_CLEAR';
export const PROSPECTMESSAGES_SET_STORE_START_ACTION_TYPE = 'PROSPECTMESSAGES_SET_STORE_START';

export const PROSPECTMESSAGES_FETCH_CONVERSATIONS_START_ACTION_TYPE = 'PROSPECTMESSAGES_FETCH_CONVERSATIONS_START';
export const PROSPECTMESSAGES_FETCH_CONVERSATIONS_SUCCESS_ACTION_TYPE = 'PROSPECTMESSAGES_FETCH_CONVERSATIONS_SUCCESS';
export const PROSPECTMESSAGES_FETCH_CONVERSATIONS_ERROR_ACTION_TYPE = 'PROSPECTMESSAGES_FETCH_CONVERSATIONS_ERROR';

export const PROSPECTMESSAGES_FETCH_CONVERSATION_START_ACTION_TYPE = 'PROSPECTMESSAGES_FETCH_CONVERSATION_START';
export const PROSPECTMESSAGES_FETCH_CONVERSATION_SUCCESS_ACTION_TYPE = 'PROSPECTMESSAGES_FETCH_CONVERSATION_SUCCESS';
export const PROSPECTMESSAGES_FETCH_CONVERSATION_ERROR_ACTION_TYPE = 'PROSPECTMESSAGES_FETCH_CONVERSATION_ERROR';

export const PROSPECTMESSAGES_SAVE_START_ACTION_TYPE = 'PROSPECTMESSAGES_SAVE_START';
export const PROSPECTMESSAGES_SAVE_SUCCESS_ACTION_TYPE = 'PROSPECTMESSAGES_SAVE_SUCCESS';
export const PROSPECTMESSAGES_SAVE_ERROR_ACTION_TYPE = 'PROSPECTMESSAGES_SAVE_ERROR';

export const SAVE_NEW_MESSAGE_START_ACTION_TYPE = 'SAVE_NEW_MESSAGE_START';
export const SAVE_NEW_MESSAGE_SUCCESS_ACTION_TYPE = 'SAVE_NEW_MESSAGE_SUCCESS';
export const SAVE_NEW_MESSAGE_ERROR_ACTION_TYPE = 'SAVE_NEW_MESSAGE_ERROR';

export const PROSPECTMESSAGES_PATCH_SUCCESS_ACTION_TYPE = 'PROSPECTMESSAGES_PATCH_SUCCESS';

type ProspectMessagesResetAction = Action<typeof PROSPECTMESSAGES_RESET_ACTION_TYPE>;

type ProspectMessagesClearAction = Action<typeof PROSPECTMESSAGES_CLEAR_ACTION_TYPE>;

type ProspectMessagesSetStoreStartAction = Action<typeof PROSPECTMESSAGES_SET_STORE_START_ACTION_TYPE>;

type ProspectMessagesFetchConversationsStartAction = Action<
    typeof PROSPECTMESSAGES_FETCH_CONVERSATIONS_START_ACTION_TYPE
>;

interface ProspectMessagesFetchConversationsSuccessAction
    extends Action<typeof PROSPECTMESSAGES_FETCH_CONVERSATIONS_SUCCESS_ACTION_TYPE> {
    payload: {
        prospectConversations: Array<ProspectConversation>;
        meta: Meta;
        filter: MessageFilterTypes | null;
        query: string | null;
    };
}

interface ProspectMessagesFetchConversationsErrorAction
    extends Action<typeof PROSPECTMESSAGES_FETCH_CONVERSATIONS_ERROR_ACTION_TYPE> {
    payload: {
        error: string | Record<string, string[]>;
    };
}

type ProspectMessagesFetchConversationStartAction = Action<
    typeof PROSPECTMESSAGES_FETCH_CONVERSATION_START_ACTION_TYPE
>;

interface ProspectMessagesFetchConversationSuccessAction
    extends Action<typeof PROSPECTMESSAGES_FETCH_CONVERSATION_SUCCESS_ACTION_TYPE> {
    payload: {
        prospectConversationDetail: ProspectConversationDetail;
        page: number;
    };
}

interface ProspectMessagesSearchConversationErrorAction
    extends Action<typeof PROSPECTMESSAGES_FETCH_CONVERSATION_ERROR_ACTION_TYPE> {
    payload: {
        error: string | Record<string, string[]>;
    };
}

type ProspectMessagesSaveStartAction = Action<typeof PROSPECTMESSAGES_SAVE_START_ACTION_TYPE>;

interface ProspectMessagesSaveSuccessAction extends Action<typeof PROSPECTMESSAGES_SAVE_SUCCESS_ACTION_TYPE> {
    payload: {
        message: ProspectMessage;
    };
}

interface ProspectMessagesSaveErrorAction extends Action<typeof PROSPECTMESSAGES_SAVE_ERROR_ACTION_TYPE> {
    payload: {
        error: string | Record<string, string[]>;
    };
}

interface ProspectMessagesPatchSuccessAction extends Action<typeof PROSPECTMESSAGES_PATCH_SUCCESS_ACTION_TYPE> {
    payload: {
        message: ProspectMessage;
    };
}

type SaveNewMessageStartAction = Action<typeof SAVE_NEW_MESSAGE_START_ACTION_TYPE>;

interface SaveNewMessageSuccessAction extends Action<typeof SAVE_NEW_MESSAGE_SUCCESS_ACTION_TYPE> {
    payload: {
        message: Message;
    };
}

interface SaveNewMessageErrorAction extends Action<typeof SAVE_NEW_MESSAGE_ERROR_ACTION_TYPE> {
    payload: {
        error: string;
    };
}

export type ProspectMessagesAction =
    | ProspectMessagesResetAction
    | ProspectMessagesClearAction
    | ProspectMessagesSetStoreStartAction
    | ProspectMessagesFetchConversationsStartAction
    | ProspectMessagesFetchConversationsSuccessAction
    | ProspectMessagesFetchConversationsErrorAction
    | ProspectMessagesFetchConversationStartAction
    | ProspectMessagesFetchConversationSuccessAction
    | ProspectMessagesSearchConversationErrorAction
    | ProspectMessagesSaveStartAction
    | ProspectMessagesSaveSuccessAction
    | ProspectMessagesSaveErrorAction
    | ProspectMessagesPatchSuccessAction
    | SaveNewMessageStartAction
    | SaveNewMessageSuccessAction
    | SaveNewMessageErrorAction;
